import { render, staticRenderFns } from "./FunFact.vue?vue&type=template&id=05417c95&scoped=true&"
import script from "./FunFact.vue?vue&type=script&lang=js&"
export * from "./FunFact.vue?vue&type=script&lang=js&"
import style0 from "./FunFact.vue?vue&type=style&index=0&id=05417c95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05417c95",
  null
  
)

export default component.exports